import { useRouter } from 'next/router'
import React, { useState, useEffect } from 'react'
import { useMutation } from '@apollo/client'
import classNames from 'classnames'

import { digitalUnit } from '~/utils'
import { useValidateAuth } from '~/hooks/useValidateAuth'
import { MyIcon } from '~/components/ui/MyIcon'
import { useDebounce } from '~/hooks/useDebounce'

import { DIS_LIKE_POST } from '~/graphqls/gqls/plaza'
import {
  ActionType,
  AffectedType,
  disLikePost,
  disLikePostVariables,
  SocialViewType,
  SquarePostType,
  PostTypes,
} from '~/graphqls/types'

type IProps = {
  post: PostTypes
  /** 踩一踩状态变更  */
  onChange?: (dislike: boolean) => void
  /** 动效中 */
  animating?: boolean
  className?: string
  colorClassName?: string
}
/** 踩一踩 */
const DisLikeBtn: React.FC<IProps> = ({
  post,
  animating,
  className,
  onChange,
  colorClassName = 'text-neutral-400',
}) => {
  const [disLike, setDislike] = useState<boolean>(false)
  const [disLikeCount, setDisLikeCount] = useState(0)
  const [disLikePostAction] = useMutation<disLikePost, disLikePostVariables>(
    DIS_LIKE_POST
  )
  const { validateIsLogin } = useValidateAuth()
  // 支持切换
  useEffect(() => {
    if (post) {
      setDislike(post.itemSocialInfo?.status?.disLiked || false)
      setDisLikeCount(post.itemSocialInfo?.disLikeCount || 0)
    }
  }, [post])
  const handleDisLike = useDebounce(() => {
    if (!validateIsLogin()) {
      return
    }
    if (animating) {
      return
    }
    let type = AffectedType.AI_ARTWORK
    switch (post.type) {
      case SquarePostType.AI_ARTWORK:
        type = AffectedType.AI_ARTWORK
        break
      case SquarePostType.ACTIVITY:
        type = AffectedType.ACTIVITY
        break
      case SquarePostType.NOTE:
        type = AffectedType.NOTE
        break
      case SquarePostType.AI_COLLECTION:
        type = AffectedType.AI_COLLECTION
        break
      default:
        break
    }

    try {
      disLikePostAction({
        variables: {
          input: {
            actionType: !disLike ? ActionType.CONFIRM : ActionType.CANCEL,
            affectedType: type,
            id: post.id,
            viewType: SocialViewType.SQUARE,
          },
        },
      })
      setDisLikeCount(!disLike ? disLikeCount + 1 : disLikeCount - 1)
      setDislike(val => {
        onChange?.(!val)
        return !val
      })
    } catch (err) {
      console.error(err)
    }
  }, [disLike, disLikeCount, post, animating])

  return (
    <>
      <div
        className={classNames(
          className,
          'flex items-center  justify-center cursor-pointer'
        )}
        onClick={handleDisLike}
      >
        <span
          className={classNames(
            ' text-xs  font-normal ',
            !disLike ? colorClassName : 'text-[#EF466F]'
          )}
        >
          踩 {disLikeCount ? digitalUnit(disLikeCount) : ''}
        </span>

        <span className="w-3 h-3 block ml-1">
          <MyIcon
            icon={!disLike ? 'cai' : 'caixuanzhong'}
            className={classNames(
              'w-3 h-3',
              !disLike ? colorClassName : 'text-[#EF466F]'
            )}
          />
        </span>
      </div>
    </>
  )
}

export default DisLikeBtn
